import "./style.css";

export const SmallCard = ({ icon, name, options, className = "" }) => {
  return (
    <div className={`smallCard ${className}`}>
      <div className="smallCard-icon">{icon}</div>
      <div className="smallCard-info">
        <div className="smallCard-name">{name}</div>
        <div className="smallCard-options">
          {options &&
            options.length > 0 &&
            options?.map((opt, idx) => (
              <button
                type="button"
                className="smallCard-option"
                onClick={opt.callback}
                key={opt.key || idx}
                tabIndex={0}
                aria-label={opt.ariaLabel || "Option"}
              >
                {opt.icon}
              </button>
            ))}
        </div>
      </div>
    </div>
  );
};
